import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=1e6bbdcc&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=1e6bbdcc&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e6bbdcc"]])

export default __exports__